<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="goals-navbar d-flex">
        <button
          class="nav-link align-items-center me-3"
          [class.active]="isButtonActive == true"
          (click)="activeTab(true)"
        >
          Active Goals
        </button>
        <button
          class="nav-link"
          [class.active]="isButtonActive == false"
          (click)="activeTab(false)"
        >
          Inactive Goals
        </button>
      </div>

      <div class="second-section d-flex align-items-center justify-content-end">
        <span matTooltip="Delete Record(s)" matTooltipPosition="above">
          <button
            *ngIf="isButtonActive"
            class="btn filter-btn ms-2"
            data-toggle="modal"
            data-backdrop="static"
            data-target="#deleteDataModal"
            (click)="openConfirmPopup(selectedgoalIds)"
          >
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/delete.svg"
            />
          </button>
        </span>
        <span matTooltip="Export Data" matTooltipPosition="above">
          <button class="btn filter-btn ms-2" (click)="exportToExcel()">
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/export.svg"
            />
          </button>
        </span>
        <span matTooltip="Filter Data" matTooltipPosition="above">
          <button
            class="btn filter-btn ms-2"
            data-bs-target="#filterData"
            data-bs-toggle="modal"
            (click)="openFilterModal('Open')"
          >
            <i
              ><img
                style="width: 25px"
                src="../../../assets/Pricingscreen/filter.svg"
            /></i>
          </button>
        </span>
        <ng-template [ngxPermissionsOnly]="['Goal:Create']">
          <div
            class="create-btn ms-3 c-pt"
            data-bs-target="#addGaolModalToggle"
            data-bs-toggle="modal"
            (click)="clearForm()"
          >
            <img src="../../../../../assets/icons/whitePlus.svg" />
            Add New
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <section class="intro">
    <div class="table-container">
      <table class="table category-table table-condensed" id="mainParent">
        <thead class="main-head sticky-top">
          <tr>
            <th scope="col" style="align-items: center; text-transform: none">
              <div class="form-check d-flex align-items-center">
                <input
                  style="height: 20px; width: 20px; margin-right: 10px"
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  [checked]="headerCheckboxSelected"
                  (change)="toggleAllCheckboxes()"
                  *ngIf="isButtonActive"
                />
                <label for="flexCheckDefault">Title</label>
              </div>
            </th>
            <th scope="col" style="text-transform: none">
              Goal Type
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter('goalType')"
                *ngIf="filtergoalIds.length > 0"
              ></i>
            </th>
            <th scope="col" style="text-transform: none">Goal Interval</th>
            <th scope="col" style="text-transform: none">Goal Group</th>
            <th scope="col" style="text-transform: none">Goal Count</th>
            <th scope="col" style="text-transform: none">Created On</th>
            <th scope="col" style="text-transform: none">Created By</th>
            <ng-template
              [ngxPermissionsOnly]="['Goal:Update']"
              ||
              [ngxPermissionsOnly]="['Goal:Delete']"
            >
              <th scope="col" style="text-align: center">Actions</th>
            </ng-template>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let goal of GoalsArray">
              <td class="d-flex g-2" colspan="2" style="align-items: center">
    <label for="" style="font-size: 14px; font-weight: 700">
      <input
        style="height: 20px; width: 20px; margin-right: 10px"
        class="form-check-input"
        type="checkbox"
        [value]="goal.goalId"
        [id]="'flexCheckGoal' + goal.goalId"
        [(ngModel)]="goal.gIsSelected"
        (change)="handleCheckboxChange($event, goal)"
        *ngIf="isButtonActive"
      />
      {{ goal.goalName }}
    </label>
  </td>
            <td>
              {{ goal.goalDescr }}
            </td>
            <td>
              {{ goal.goalIntervals }}
            </td>
            <td>
              {{ goal.groupName }}
            </td>
            <td style="text-align: end; padding-right: 30px; width: 132px">
              {{
                goal.goalValueId == 1 ? (goal.goalCnt | currency) : goal.goalCnt
              }}
            </td>
            <td>{{ goal.createdDt | date : "MM/dd/yyyy" }}</td>
            <td>{{ goal.userName }}</td>
            <ng-template
              [ngxPermissionsOnly]="['Goal:Update']"
              ||
              [ngxPermissionsOnly]="['Goal:Delete']"
            >
              <td style="text-align: center">
                <div class="btn-group dropleft" style="gap: 10px">
                  <ng-template [ngxPermissionsOnly]="['Goal:Update']">
                    <button
                      type="button"
                      class="action-drop me-2"
                      data-bs-target="#addGaolModalToggle"
                      data-bs-toggle="modal"
                      (click)="getGoalById(goal.goalId)"
                    >
                      <i matTooltipPosition="above" matTooltip="Edit Record">
                        <img
                          style="width: 25px; height: 25px"
                          src="../../../assets/Pricingscreen/update.svg"
                      /></i>
                    </button>
                  </ng-template>
                  <ng-template
                    [ngxPermissionsOnly]="['Goal:Delete']"
                    *ngIf="isButtonActive"
                  >
                    <span matTooltip="Delete Record" matTooltipPosition="above">
                      <button
                        type="button"
                        class="action-drop"
                        data-toggle="modal"
                        data-backdrop="static"
                        data-target="#deleteDataModal"
                        (click)="openConfirmPopup(goal.goalId)"
                      >
                        <i
                          ><img
                            style="width: 25px; height: 25px"
                            src="../../../assets/Pricingscreen/delete.svg"
                        /></i>
                      </button>
                    </span>
                  </ng-template>
                </div>
              </td>
            </ng-template>
          </tr>
        </tbody>
      </table>
      <div
        *ngIf="isLoading"
        class="d-flex justify-content-center align-items-center"
        style="height: 56vh; width: 100%"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div
        *ngIf="GoalsArray.length == 0"
        class="nodata"
        style="
          height: 56vh;
          width: 100%;
          display: flex;
          margin: auto;
          align-items: center;
          margin: auto;
          border: none;
        "
      >
        <p
          style="
            margin: auto;
            border: transparent !important;
            font-size: 2rem;
            color: #a4a4a4;
          "
        >
          No Data Available
        </p>
      </div>
    </div>
  </section>
</div>

<!--Boostrap modal for filter data-->
<div
  class="modal fade"
  id="filterData"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Filters</h5>
      </div>
      <div class="modal-body p-0">
        <div class="filter d-flex">
          <div class="filter-labels">
            <h6 class="ps-4">Lists</h6>
            <div class="filter-labels-wrapper">
              <ul class="list-unstyled">
                <li (click)="selectedFilterCategory('goalType')"
                 [ngClass]="{ 'active': filterName === 'goalType' }">
                  Goal Type
                  <br />
                  <p *ngIf="filtergoalIds.length > 0">
                    {{ filtergoalIds.length }} selected
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="filter-data">
            <h6 class="ps-2">Selected by: {{ filterName }}</h6>
            <div class="filter-data-wrapper">
              <div class="row" *ngIf="filterName == 'goalType'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="let data of GoalsArrayforFilter; let idx = index"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                    (click)="collectFilterParameters(data.goalTypeId)"
                  >
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                      >{{ data.goalDescr }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <div class="footer-wrapper">
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="openFilterModal('Close')"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="getFilterData()"
            style="background-color: rgb(23, 95, 145); color: white"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for add goal-->
<div
  class="modal fade"
  id="addGaolModalToggle"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="custom-modal-header modal-header">
        <h5 class="mb-0">{{ isEditable ? "Update Goal" : "Add New Goal" }}</h5>
      </div>
      <div class="custom-modal-body modal-body">
        <div class="modal-body-wraapper">
          <div class="selector">
            <div class="custom-label">
              <label for="labelTypeInput" class="form-label"
                >Goal Name <span class="text-danger">*</span>
              </label>
              <p>:</p>
            </div>
            <input
              type="text"
              class="form-control goal-input"
              id="labelTypeInput"
              name="goalName"
              placeholder="Enter goal name"
              [(ngModel)]="goal.goalName"
            />
          </div>
          <div class="selector">
            <div class="custom-label">
              <label for="" style="margin-right: 4px"
                >Goal Type <span class="text-danger">*</span>
              </label>
              <p>:</p>
            </div>
            <select
              class="form-select goal-input"
              aria-label="Default select example"
              name="goalTypeID"
              [(ngModel)]="goal.goalTypeId"
              (change)="filterGoalGroup(goal.goalTypeId)"
            >
              <option [ngValue]="0" hidden>Select</option>
              <option
                *ngFor="let goaltype of goalTypes"
                [ngValue]="goaltype.goalTypeId"
              >
                {{ goaltype.goalDescr }}
              </option>
            </select>
          </div>
          <div class="selector">
            <div class="custom-label">
              <label for="" style="margin-right: 4px"
                >Goal Interval <span class="text-danger">*</span>
              </label>
              <p>:</p>
            </div>
            <select
              class="form-select goal-input"
              aria-label="Default select example"
              name="goalIntervalID"
              [(ngModel)]="goal.goalIntervalId"
            >
              <option [ngValue]="0" hidden>Select</option>
              <option
                *ngFor="let interval of goalIntervals"
                [ngValue]="interval.goalIntervalId"
              >
                {{ interval.goalIntervals }}
              </option>
            </select>
          </div>
          <div class="selector">
            <div class="custom-label">
              <label for="" style="margin-right: 4px"
                >Goal Value <span class="text-danger">*</span>
              </label>
              <p>:</p>
            </div>
            <select
              class="form-select goal-input"
              aria-label="Default select example"
              name="goalValueID"
              [(ngModel)]="goal.goalValueId"
            >
              <option [ngValue]="0" hidden>Select</option>
              <option
                *ngFor="let value of goalValue"
                [ngValue]="value.goalValueId"
              >
                {{ value.goalValue }}
              </option>
            </select>
          </div>
          <div class="selector">
            <div class="custom-label">
              <label for="" style="margin-right: 4px"
                >Goal Group <span class="text-danger">*</span>
              </label>
              <p>:</p>
            </div>
            <select
              class="form-select goal-input"
              aria-label="Default select example"
              name="goalGroupID"
              [(ngModel)]="goal.goalGroupId"
            >
              <option [ngValue]="0" hidden>Select</option>
              <option
                *ngFor="let grps of filteredGoalGroup"
                [ngValue]="grps.goalGroupId"
              >
                {{ grps.groupName }}
              </option>
            </select>
          </div>
          <div class="selector">
            <div class="custom-label">
              <label
                for="labelSizeInput"
                class="form-label"
                style="margin-right: 3px"
                >Goal Count <span class="text-danger">*</span>
              </label>
              <p>:</p>
            </div>
            <input
              type="text"
              class="form-control goal-input"
              id="labelSizeInput"
              name="goalCnt"
              placeholder="Enter goal count"
              [(ngModel)]="goal.goalCnt"
              maxlength="7"
            />
          </div>
          <!--Radio nbuttons for status-->
          <div class="d-flex align-items-center justify-content-between">
            <div class="custom-label">
              <span style="margin-left: 17px">Status</span>
              <p>:</p>
            </div>
            <div class="get-status">
              <div class="form-check me-5">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="active"
                  [(ngModel)]="goal.active"
                  [value]="true"
                  checked
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Active
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="inactive"
                  [(ngModel)]="goal.active"
                  [value]="false"
                />
                <label class="form-check-label" for="flexRadioDefault2">
                  Inactive
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button
          class="btn modal-btn me-2"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="highlightedRow(null)"
        >
          Cancel
        </button>
        <button
          class="btn modal-btn"
          style="width: 130px"
          [ngClass]="isValidated() ? 'add-btn' : 'disable-btn'"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="isValidated() ? createGoal(goal) : ''"
        >
          {{ isEditable ? "Update Goal" : "Add Goal" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for deleting Goal -->
<div
  class="modal fade"
  id="deleteDataModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="deleteButtonClickedWithSelection">
        <h5>Delete</h5>
      </div>
      <div class="modal-header" *ngIf="deleteButtonClickedWithoutSelection">
        <h5>No Record Selected !</h5>
      </div>
      <div class="modal-body" *ngIf="deleteButtonClickedWithSelection">
        <div class="modal-body-wraapper">
          <p>
            Are you sure you want to delete the Selected Records?<br />
            Or you can make the Selected Records inactive.
          </p>
          <p class="fw-bold mt-3">
            Once deleted, all the saved data will get deleted.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="deleteButtonClickedWithoutSelection">
        <div class="modal-body-wraapper">
          <p>Please select one or more records to delete.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button
          class="btn modal-btn me-2"
          data-dismiss="modal"
          aria-label="Close"
          #modalConfirmCloseButton
          (click)="highlightedRow(null)"
        >
          Close
        </button>
        <button
          button
          class="btn modal-btn"
          data-dismiss="modal"
          aria-label="Close"
          *ngIf="deleteButtonClickedWithSelection"
          style="background-color: rgb(23, 95, 145); color: white"
          (click)="deleteGoals(deleteParameter)"
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>
